import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Paper, IconButton, Collapse } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import OutletCard from './OutletCard';

const OutletCategorySection = ({ title, outlets, expanded, setExpanded, onTypeChange, bgColor = 'primary.main', initialVisibleCount = 4 }) => {
  return (
    <Paper sx={{ height: '100%', mt: { xs: 6, md: 0 } }}>
      <Box
        sx={{
          p: 2,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: bgColor,
          borderRadius: '10px 10px 0 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant="h6" sx={{ color: 'white' }}>
          {title} ({outlets.length})
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="button" sx={{ color: 'white', opacity: 0.9 }}>
            {expanded ? 'Show Less' : 'Show More'}
          </Typography>
          <IconButton
            size="small"
            sx={{
              color: 'white',
              transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          >
            <KeyboardArrowDownIcon />
          </IconButton>
        </Box>
      </Box>
      {outlets.length > 0 ? (
        <>
          {outlets.slice(0, initialVisibleCount).map((outlet) => (
            <OutletCard key={outlet.id} outlet={outlet} onTypeChange={onTypeChange} />
          ))}
          <Collapse in={expanded}>
            {outlets.slice(initialVisibleCount).map((outlet) => (
              <OutletCard key={outlet.id} outlet={outlet} onTypeChange={onTypeChange} />
            ))}
          </Collapse>
        </>
      ) : (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            No {title.toLowerCase()} yet
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

OutletCategorySection.propTypes = {
  title: PropTypes.string.isRequired,
  outlets: PropTypes.array.isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  bgColor: PropTypes.string,
  initialVisibleCount: PropTypes.number,
};

export default OutletCategorySection;
